import React from 'react';
import { useDispatch } from 'react-redux';
import FlipIcon from '@mui/icons-material/Flip';

import { hasAssemblyPermission as hasAssemblyPermissionSelector } from '@paragon/login-tools';

import { useAppMonitor } from '../../../monitor';
import { isLayoutCameraInUse } from '../../../store/selectors/layoutModeSelectors';
import { cameraSlice } from '../../../store/slices/camera/cameraSlice';
import { useAppSelector } from '../../hooks';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export default function ReverseButton() {
  const monitor = useAppMonitor();
  const dispatch = useDispatch();

  const hasAssemblyPermission = useAppSelector(hasAssemblyPermissionSelector);

  const disabled = useAppSelector(isLayoutCameraInUse);
  const isReversed = useAppSelector((state) => state.camera.designSettings.reversed);

  if (!hasAssemblyPermission) return null;

  return (
    <ToolbarIconButton
      icon={<FlipIcon />}
      title={`${isReversed ? 'Unreverse' : 'Reverse'} Camera`}
      toggleValue={isReversed}
      disabled={disabled}
      onClick={() => {
        dispatch(cameraSlice.actions.designCameraReversed());
        monitor.recordInteraction('Component Reversed');
      }}
    />
  );
}
